import type { AnyExtension } from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';
import Placeholder from '@tiptap/extension-placeholder';
import TextAlign from '@tiptap/extension-text-align';
import Highlight from '@tiptap/extension-highlight';
import { Color } from '@tiptap/extension-color';
import { TextStyle } from '@tiptap/extension-text-style';
import { Table } from '@tiptap/extension-table';
import { TableRow } from '@tiptap/extension-table-row';
import { TableCell } from '@tiptap/extension-table-cell';
import { TableHeader } from '@tiptap/extension-table-header';

/**
 * Everything {@link RichTextEditor} is built from.
 *
 * Image support is passed in rather than listed here because it depends on
 * where the consumer can store an upload; see `useInlineImageSupport`.
 *
 * Registering one extension twice is not a warning to shrug at — the schema
 * ends up with two nodes of the same name and TipTap picks between them
 * arbitrarily. `link` in particular is part of StarterKit as of v3, so it is
 * configured through the kit instead of being added alongside it.
 */
export function buildEditorExtensions(
	imageExtensions: AnyExtension[],
	placeholder: string
): AnyExtension[] {
	return [
		StarterKit.configure({
			heading: { levels: [1, 2, 3] },
			bulletList: { keepMarks: true, keepAttributes: false },
			orderedList: { keepMarks: true, keepAttributes: false },
			link: { openOnClick: false, autolink: true },
		}),
		...imageExtensions,
		TextAlign.configure({ types: ['heading', 'paragraph'] }),
		TextStyle,
		Color,
		Highlight.configure({ multicolor: true }),
		Table.configure({ resizable: true }),
		TableRow,
		TableCell,
		TableHeader,
		Placeholder.configure({ placeholder }),
	];
}
